import { IEventDataSource } from "@/types/interfaces";
import { BigBashEvent, Game, GamePoint } from "@/types/types";
import { IntervalPoller, OnPollingStarted, OnPollingStopped } from "@infrastructure/IntervalPoller";
import { mergeGamePointsForGame } from "./gamePointsMergeHandler";

export class GamePointsPoller {
	private readonly intervalPoller: IntervalPoller<BigBashEvent, GamePoint[]>;

	constructor(
		onPollingStarted: OnPollingStarted,
		onPollingStopped: OnPollingStopped<BigBashEvent>,
		game: Game,
		event: BigBashEvent,
		eventDataSource: IEventDataSource
	) {
		this.intervalPoller = new IntervalPoller<BigBashEvent, GamePoint[]>(
			(currentEvent: BigBashEvent): Promise<GamePoint[]> => eventDataSource.getGamePoints(currentEvent.id, game.id),
			(currentEvent: BigBashEvent, gamePoints: GamePoint[]): BigBashEvent =>
				({ ...currentEvent, game_points: mergeGamePointsForGame(currentEvent, game.id, gamePoints) }),
			onPollingStarted,
			onPollingStopped,
			event,
			'game points'
		);
	}

	invalidateInFlightPollRequestAndResetSchedule(): void {
		this.intervalPoller.invalidateInFlightPollRequestAndResetSchedule();
	}

	setEvent(event: BigBashEvent): void {
		this.intervalPoller.setState(event);
	}

	start(): void {
		this.intervalPoller.start();
	}

	stop(): void {
		this.intervalPoller.stop();
	}

	resetSchedule(): void {
		this.intervalPoller.resetSchedule();
	}
}
